import { render, staticRenderFns } from "./ParametricSend.vue?vue&type=template&id=4928c791"
import script from "./ParametricSend.vue?vue&type=script&lang=js"
export * from "./ParametricSend.vue?vue&type=script&lang=js"
import style0 from "./ParametricSend.vue?vue&type=style&index=0&id=4928c791&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports